// removed by extract-text-webpack-plugin
module.exports = {"authorizationSSOSuccess":"AuthorizationSSOSuccess__authorizationSSOSuccess","title":"AuthorizationSSOSuccess__title","providerLogo":"AuthorizationSSOSuccess__providerLogo","congrat":"AuthorizationSSOSuccess__congrat","message":"AuthorizationSSOSuccess__message","growDotQello":"AuthorizationSSOSuccess__growDotQello","growDotBlue":"AuthorizationSSOSuccess__growDotBlue","growDotGolden":"AuthorizationSSOSuccess__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationSSOSuccess/AuthorizationSSOSuccess.scss
// module id = 1896
// module chunks = 0